import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

import { useState, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'providers/AuthProvider'
import apiClient, { handleAPIError } from 'helpers/apiService';
import { MessageType } from 'providers/SSEProvider';
import NotificationItemTHEach from 'components/common/NotificationItemTHEach';

const Notifications = () => {
  const auth = useAuth();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  const breadcrumbItems: PageBreadcrumbItem[] = [
    {
      label: 'Dashboard',
      url: '/dashboard/home'
    },
    {
      label: 'Notifications',
      active: true
    }
  ];

  const [notifications, setNotifications] = useState<MessageType[]>([]);

  const fetchData = async () => {
    //console.log("SSEProvider: fetchData");
    try {
      const response = await apiClient.get(
        '/v1/notifications?limit=-1',
        {
          headers: {
            'accept': 'application/json',

          }
        }
      );
      setNotifications(response.data);

    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Fetch data immediately when the component mounts
    fetchData();
  }, []);

  // Get today's date in YYYY-MM-DD format
  const today = useMemo(() => {
    const now = new Date();
    return now.toISOString().split('T')[0];
  }, []);

  // Get yesterday's date in YYYY-MM-DD format
  const yesterday = useMemo(() => {
    const now = new Date();
    now.setDate(now.getDate() - 1);
    return now.toISOString().split('T')[0];
  }, []);

  // Filter notifications to include only those received today
  const todayNotifications = useMemo(() => {
    return notifications.filter(notification => {
      const notificationDate = new Date(notification.inserted_at).toISOString().split('T')[0];
      return notificationDate === today;
    });
  }, [notifications, today]);

  // Filter notifications to include only those received yesterday
  const yesterdayNotifications = useMemo(() => {
    return notifications.filter(notification => {
      const notificationDate = new Date(notification.inserted_at).toISOString().split('T')[0];
      return notificationDate === yesterday;
    });
  }, [notifications, yesterday]);

  // Filter notifications to include only those received before yesterday
  const olderNotifications = useMemo(() => {
    return notifications.filter(notification => {
      const notificationDate = new Date(notification.inserted_at).toISOString().split('T')[0];
      return notificationDate < yesterday;
    });
  }, [notifications, yesterday]);



  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <PageBreadcrumb items={breadcrumbItems} />
      <h2 className="mb-4">{t("Notifications.title")}</h2>
      <h3 className="text-black mb-3 ">{t("Notifications.today")}</h3>
      <div className="mx-n4 mx-lg-n6 mb-5 border-top border-300">
        {todayNotifications.map((notification, index) => (
          <NotificationItemTHEach
            notification={notification}
            type="pageItem"
            className={classNames({
              'border-bottom': index !== notifications.length - 1
            })}
            key={notification.notification_id}
          />
        ))}
      </div>
      <h3 className="text-black mb-3 ">{t("Notifications.yesterday")}</h3>
      <div className="mx-n4 mx-lg-n6 mb-9 border-top border-300">
        {yesterdayNotifications.map((notification, index) => (
          <NotificationItemTHEach
            notification={notification}
            type="pageItem"
            className={classNames({
              'border-bottom': index !== notifications.length - 1
            })}
            key={notification.notification_id}
          />
        ))}
      </div>

      <h3 className="text-black mb-3 ">{t("Notifications.older")}</h3>
      <div className="mx-n4 mx-lg-n6 mb-9 border-top border-300">
        {olderNotifications.map((notification, index) => (
          <NotificationItemTHEach
            notification={notification}
            type="pageItem"
            className={classNames({
              'border-bottom': index !== notifications.length - 1
            })}
            key={notification.notification_id}
          />
        ))}
      </div>
    </div>
  );
};

export default Notifications;
